export default __webpack_public_path__ + "static/media/valo2.9bd67b9e.jpg";